import { lazy } from 'react';

export const LoginPage = lazy(() => import('@/features/auth/pages/LoginPage'));
export const ForgotPasswordPage = lazy(() => import('@/features/auth/pages/ForgotPasswordPage'));
export const ResetPasswordPage = lazy(() => import('@/features/auth/pages/ResetPasswordPage'));
export const VerifyEmailPage = lazy(() => import('@/features/auth/pages/VerifyEmailPage'));

export const CheckinPage = lazy(() => import('@/features/checkin/pages/CheckinPage'));

export const DashboardPage = lazy(() => import('@/features/dashboard/pages/DashboardPage'));
export const ClientListPage = lazy(() => import('@/features/clients/pages/ClientListPage'));
export const ClientConfigurationPage = lazy(
  () => import('@/features/clients/pages/ClientConfigurationPage'),
);
export const ProfilePage = lazy(() => import('@/features/profile/pages/ProfilePage'));
export const ChangePasswordPage = lazy(() => import('@/features/profile/pages/ChangePasswordPage'));

export const ComingSoonPage = lazy(() => import('@/pages/common/ComingSoonPage'));

export const GuestListPage = lazy(() => import('@/features/guests/pages/GuestListPage'));

export const ReservationLogListPage = lazy(
  () => import('@/features/logs/pages/ReservationLogListPage'),
);
export const OccupancyReportPage = lazy(() => import('@/features/logs/pages/OccupancyReportPage'));
export const TopGuestsReportPage = lazy(() => import('@/features/logs/pages/TopGuestsReportPage'));
export const CancellationsReportPage = lazy(
  () => import('@/features/logs/pages/CancellationsReportPage'),
);

export const ReservationListPage = lazy(
  () => import('@/features/reservations/pages/ReservationListPage'),
);
export const ReservationFormPage = lazy(
  () => import('@/features/reservations/pages/ReservationFormPage'),
);
export const ReservationCalendarPage = lazy(
  () => import('@/features/reservations/pages/ReservationCalendarPage'),
);

export const RestaurantListPage = lazy(
  () => import('@/features/restaurants/pages/RestaurantListPage'),
);

export const RestaurantHoursPage = lazy(
  () => import('@/features/restaurant-hours/pages/RestaurantHoursPage'),
);

export const RestaurantTablesPage = lazy(
  () => import('@/features/restaurant-tables/pages/RestaurantTablesPage'),
);

export const RateListPage = lazy(() => import('@/features/rates/pages/RateListPage'));

export const ChildCategoryListPage = lazy(
  () => import('@/features/child-categories/pages/ChildCategoryListPage'),
);

export const ConfigurationListPage = lazy(
  () => import('@/features/configurations/pages/ConfigurationListPage'),
);

export const UserListPage = lazy(() => import('@/features/users/pages/UserListPage'));

export const TemplateListPage = lazy(() => import('@/features/templates/pages/TemplateListPage'));

export const SmtpSettingsPage = lazy(
  () => import('@/features/system-settings/pages/SmtpSettingsPage'),
);
export const RecaptchaSettingsPage = lazy(
  () => import('@/features/system-settings/pages/RecaptchaSettingsPage'),
);
